module.exports = __webpack_public_path__ + "static/media/Fighting Spirit-2-01.1de89d21.svg";